import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CapabilitiesPage from "../pages/capabilities/page";
import CompliancePage from "../pages/compliance/page";
import ScenariosPage from "../pages/scenarios/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/capabilities",
    element: <CapabilitiesPage />,
  },
  {
    path: "/compliance",
    element: <CompliancePage />,
  },
  {
    path: "/scenarios",
    element: <ScenariosPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;